import Button from '@mui/material/Button';
import { Link } from "react-router-dom";
function Home() {
    return (<div>
      <h1>Welcome to SmashBuzz!</h1>
      <p>This site displays twitter metrics related to upcoming and recent Smash Brothers tournaments hosted on smash.gg.</p>
      <p>(currently only Smash Brothers Melee)</p>
      <br/>
      <Link to="/Tournaments"><Button variant="outlined" color="primary">View Tournaments Table</Button></Link>
      <br/><br/>
      <Link to="/Chart"><Button variant="outlined" color="primary">View Tournaments Chart</Button></Link>
    </div>);
}

export default Home;
